module.exports = __webpack_public_path__ + "img/icon-yjs.6471de64.png";